import { render, staticRenderFns } from "./MoreAction.vue?vue&type=template&id=504538e1"
import script from "./MoreAction.vue?vue&type=script&lang=ts"
export * from "./MoreAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports